var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"groupList"},[_c('loading'),_vm._v(" "),_vm._l((_vm.groups),function(group){return _c('router-link',{key:group.id,attrs:{"to":{ name: 'GroupDetail', params: { id: group.id } }}},[_c('group',{attrs:{"group":group}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60070bb7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Groups.vue
// module id = null
// module chunks = 